const { populate } = require('@/functions/objects');

class KitchenItemOption {
    /**
     * @type {number}
     */
    itemID;

    /**
     * @type {string}
     */
    itemName;

    /**
     * @type {number}
     */
    optionSetID;

    /**
     * @type {string}
     */
    key;

    // Note we don't have the option set name here.
    // We could load that by using the optionSetID if needed.

    constructor(data = {}) {
        populate(this, data);

        this.key = `${this.optionSetID}:${this.itemID}`;
    }
}

module.exports = KitchenItemOption;
